import { InjectionToken } from '@angular/core';
import { SessionMonitorConfig } from '@/core/util/session-monitor.config';


export const SESSION_MONITORING_TOKEN = new InjectionToken<SessionMonitorConfig>('SESSION_MONITORING_TOKEN');
